import { gql } from '@apollo/client';

export const DEDUCT_USER_DIAMONDS = gql`
  mutation deductUserDiamonds($input: DeductUserDiamondsInput!) {
    deductUserDiamonds(input: $input) {
      dryRun
      minBalance
      processedCount
      deductedCount
      skippedCount
      failedCount
      totalDeducted
      results {
        userId
        status
        requestedAmount
        balanceBefore
        balanceAfter
        actualDeducted
        error
      }
    }
  }
`;
